<template>
  <div class="mit-equipment-page mit-page ">
    <BaseMitLoading :show="loading" :overlayFullscreen="false"/>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card " >
            <v-card-title>Equipment</v-card-title>
            <v-card-subtitle class="caption">CSAIL Equipment</v-card-subtitle>
            <BaseMitDataTable title="Reservations" :editable="false" :headers="headers" :items="reservations">
                <template v-slot:tableHeader="{ title, search }">
                    <!-- Just clear this out as it is just a simple table, no need for header or search -->
                    <div><h3><a :href="quipUrl" target="_blank">TIG Equipment reservations</a></h3></div>
                </template>
                <!-- Override the default row so we can do some special styling and html -->
                <template v-slot:item="{ item, search }">
                    <tr @click="handleRowClick" style="cursor: pointer;">
                        <td>{{item.equipment_name}}</td>
                        <td>
                            <div class="divRaw2 pa-2">{{ item.checkout_date_local_Readable }}  --  {{ item.due_date_local_Readable }}

                            <!-- future reservations -->
                            <div v-if="item.time_now < item.checkout_timestamp">
                              <div class="caption">Don't Forget to pick up in {{item.checkout_date_localfromnow}}</div>
                            </div>

                            <!-- ongoing reservations -->
                            <div v-else-if="(item.time_now > item.checkout_timestamp)&& (item.time_now < item.due_timestamp)">
                              <div class="caption">Due Date is in {{item.due_date_localfromnow}}</div>
                            </div>

                            <!-- past due reservations  -->
                            <div v-else>
                              <div class="red--text font-weight-medium">
                                <v-icon style="color:red">mdi-calendar-alert</v-icon>
                                Passed due Date by {{item.due_date_localfromnow}}
                              </div>
                            </div>
                          </div>
                        </td>
                    </tr>
                </template>
            </BaseMitDataTable>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
import BaseMitDataTable from '../../base/components/BaseMitDataTable.vue';
import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';
import MitEquipmentApiService from "../services/MitEquipmentApiService.js";

export default {
  name: "MitEquipmentPage",
  components: {
      BaseMitLoading,
      BaseMitDataTable
  },
  data: function () {
    return {
        loading:true,
        equipmentService: null,
        headers:[
            {text: 'Name',sortable: true,value: 'equipment_name',},
            // temporary hiding spaces
            // {text: 'Spaces',sortable: false,value: 'accessSpacesDisplay',},
            {text: 'Reservation Dates',sortable: true,value: 'checkout_date_local_Readable',}
          ],
        reservations: [],
        quipUrl:null
    };
  },
  created() {

  },
  mounted() {
      this.quipUrl = BaseMitConfigService.get('CLIENT_QUIP_URL');
      this.equipmentService = new MitEquipmentApiService();
      this.reservationRefresh();
  },
  methods: {
      handleRowClick(){
          window.open(this.quipUrl, '_blank').focus();
      },
      reservationRefresh () {
        this.loading = true;
        this.equipmentService.getMyReservation()
            .then((data) => {
                this.loading = false;
                this.reservations = data;
            })
            .catch((error) => {
                this.loading = false;
                console.log("An error occurred trying to get user list", error);
            });
    },
  },
};
</script>

<style lang="scss" scoped>
    .mit-info-card {
      width: 100%;
      max-width: 1600px;
      font-size: .875rem;
      padding: 20px;
      max-height: 100%;
    }
    .flex-container {
      display: flex;
      background-color: #fefefe;
    }
    .flex-container > div {
      padding: 10px;
      border-bottom: thin solid #ccc;
    }
    @media only screen and (max-width: 600px) {
      .flex-container > div {
        padding: 3px;
      }
    }
    .flex-container > .divRaw1 {
      width: 40%;
    }
    .flex-container > .divRaw2 {
      width: 60%;
    }
</style>
